<template>
  <div>
    <h4 class="payment-type-title">
      <strong>{{ $t("choosePaymentType") }}</strong>
    </h4>

    <p class="payment-type-desc u-color-muted u-margin-bottom-small">
      {{ $t("paymentTypeDesc") }}
    </p>
    <div class="u-margin-top-small">
      <p class="o-alert o-alert--warning u-font-size-small">
        {{ $t("reservationAlert") }}
      </p>
    </div>
    <div class="payment-options">
      <div
        v-for="payment in paymentsComputed"
        :key="payment.value"
        class="u-padding-xsmall u-border u-radius-g u-margin-bottom-xsmall u-hover-select u-display-flex u-align-items-center u-justify-content-space-between"
        :class="{ active: value === payment.value }"
        @click="selectPaymentType(payment.value)"
      >
        <div class="u-display-flex u-align-items-center">
          <div class="payment-option-icon u-margin-right-small">
            <img :src="payment.image" width="30" alt="" />
          </div>
          <div class="payment-option-content">
            <div class="payment-option-title">
              <strong>{{ payment.title }}</strong>
            </div>
            <div class="payment-option-desc u-color-muted">
              <small> {{ payment.desc }}</small>
            </div>
          </div>
        </div>
        <div class="payment-option-check">
          <input
            type="radio"
            name="payment-type"
            :checked="value === payment.value"
            class="c-form-radio"
            id=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectPaymentType",
  data() {
    return {
      payments: [
        {
          image: require("@/assets/images/credit-card.gif"),
          value: "OnlinePayment",
          title: this.$t("onlinePayment"),
          desc: this.$t("onlinePaymentDescription"),
        },
        {
          image: require("@/assets/images/cash.gif"),
          value: "Cash",
          title: this.$t("cash"),
          desc: this.$t("cachDescription"),
        },
      ],
    };
  },
  props: {
    value: {
      type: String,
      default: "cash",
    },
    onlyOnline: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    selectPaymentType(type) {
      if (this.value === "OnlinePayment") return this.$emit("input", "Cash");
      this.$emit("input", type);
    },
  },
  computed: {
    paymentsComputed() {
      return this.onlyOnline
        ? this.payments.filter((p) => p.value === "OnlinePayment")
        : this.payments;
    },
  },
};
</script>
